module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium.ab0e15c3.woff2";